import EmailService from "api/emailService";
import listService from "api/listService";
import classNames from "classnames";
import Avatar from "components/Avatar";
import Loading from "components/Loading";
import PDFViewer from "components/PDFViewer";
import EmailViewer from "components/EmailViewer";
import { IAttachment } from "dto/IAttachment";
import { IPackage } from "dto/IPackage";
import moment from "moment";
import {
  RefObject,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { decryptPackage } from "utils/decryptPackage";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import PackageCaseModal from "components/PackageCaseModal";

import tagsService from "api/tagsService";
import FwdIcon from "assets/icons/fwd.svg?react";
import GroupIcon from "assets/icons/groups.svg?react";
import Button from "components/Button";
import Chip from "components/Chip";
import ErrorScreen from "components/ErrorScreen";
import IconsState from "components/IconsState";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import MultiPackageModal from "components/MultiPackageModal";
import OptionsCard from "components/OptionsCard/OptionsCard";
import PackageAttachment from "components/PackageAttachment";
import PackageReceiversModal from "components/PackageReceiversModal";
import ReceiveModal from "components/ReceiveModal";
import SelectedElementsPanel from "components/SelectedElementsPanel";
import KeysContext from "contexts/KeysContext";
import ModalsManagerContext, {
  InvoiceRegistryModalOptions,
  ContractRegistryModalOptions,
} from "contexts/ModalsManager";
import PackagesContext from "contexts/PackagesContext";
import CPluginContext from "contexts/PluginContext";
import settingsContext, { IOptionType } from "contexts/SettingsContext";
import { IKey } from "dto/IKey";
import { ItemKind } from "dto/IKindItems";
import { ITag, TagType } from "dto/ITag";
import usePDF from "hooks/usePDF";
import { useAuth } from "react-oidc-context";
import { decodeAndFetchImages } from "utils/decodeAndFetchImages";
import { getKeys } from "utils/getKeys";
import { getUserId } from "utils/getUserId";
import { addToUrl, hasImages, parseHTML } from "utils/parseHTML";
import { sanitizeUserHtml } from "utils/sanitizeUserHtml";
import { axiosInstance } from "api/axios";
import ICALHeader from "components/ICALHeader";
import PluginNotExist from "components/PluginNotExist";
import EmptyPanel from "components/EmptyPanel";
import Popper from "components/Popper";
import ChooseTagNew from "components/ChooseTagNew";
import ZipAttachToDossierModal from "components/ZipAttachToDossierModal";
import StatusModal from "components/StatusModal";
import { IStatus } from "dto/IStatus";
import { IAttachToCaseFolderLink } from "api/casesService";
import AttachToCaseModalAttachments from "components/AttachCaseModalNew/AttachToCaseModalAttachments";
import ExpiredModal from "components/ExpiredModal";
import PendingPaymentModal from "components/PendingPaymentModal";
import MetricDatesModal from "components/MetricDatesModal";
import BackIcon from "assets/icons/back.svg?react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import AddIcon from "assets/icons/add.svg?react";
import TrashIcon from "assets/icons/bin.svg?react";
import CaseIcon from "assets/icons/case.svg?react";
import ReplyIcon from "assets/icons/reply.svg?react";
import { useTranslation } from "react-i18next";

const Package: FC<Props> = ({
  className = "",
  headerClassName = "",
  kind,
  packageId,
  onDownload,
  showVersion,
  cc,
  selectedElements,
  setSelectedElements,
  isMobile = false,
}) => {
  const { t } = useTranslation();
  const { checkIsAllowed, showNotSupportedNotification, checkIsArchive } =
    usePDF();
  const reference = useRef(null);
  const receiversReference = useRef(null);
  const receiversCcReference = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const PDFId = queryParams.get("pdf");
  const {
    packageId: PID,
    letterId,
    status,
    versionId,
    threadId,
  } = useParams();
  const [findedTags, setFindedTags] = useState<ITag[]>([]);
  const { packages, setPackages } = useContext(PackagesContext);
  const isSending = status === "outcoming";
  const auth = useAuth();
  const userId = getUserId(auth.user!);
  const navigate = useNavigate();

  const [useIframe, setUseIframe] = useState(false);

  const [showCase, setShowCase] = useState(false);

  const [showMulti, setShowMulti] = useState(false);
  const [showReceivers, setShowReceivers] = useState(false);
  const [showCcReceivers, setShowCcReceivers] = useState(false);

  const [showArchive, setShowArchive] = useState<IAttachment>(null);
  const [showEditTags, setShowEditTags] = useState(false);
  const [showEditStatus, setShowEditStatus] = useState(false);
  const [tagPopperRef, setTagPopperRef] = useState<HTMLElement>(null);
  const tagsRef = useRef<HTMLDivElement>(null);
  const {
    blob,
    removeBlob,
    create,
    isDownload,
    showInstallPlugin,
    setShowInstallPlugin,
    attachment: previewAttachment,
  } = usePDF();

  const {
    data: packageData,
    refetch,
    isLoading,
  } = listService.useGetPackage({
    FilterId: packageId ?? "",
    Kind: kind ? Number(kind) : ItemKind.None,
  });

  const [allowImages, setAllowImages] = useState(true);
  const [canImages, setCanImages] = useState(false);

  const refWrapper = useRef(null);
  const refWrapper2 = useRef(null);
  const [, setShowAttach] = useState(false);
  const { mutate: manageDossier } = listService.useManageDossier();

  const [showDateMetric, setShowDateMetic] = useState<boolean>(false);
  const [contentLoaded, setContentLoaded] = useState<boolean>(false);
  const dateRef = useRef();

  const [editStatusRef, setEditStatusRef] =
    useState<RefObject<HTMLDivElement>>();
  const [editTagRef, setEditTagRef] = useState<RefObject<HTMLDivElement>>();

  // useGetPreview
  // const { mutate: getAnnotations } = annotationService.useGet();

  const pack: IPackage = useMemo(
    () => (packageData?.data?.Items?.[0] as IPackage) ?? [],
    [packageData, packageData?.data],
  );
  const packCcReceivers = pack?.Receivers?.filter((x) => x.Cc || x.Bcc);

  const { data: tagsData } = tagsService.useGetTags();
  const tags: ITag[] = useMemo(() => tagsData?.data ?? [], [tagsData]);

  const packFromContext = useMemo(
    () => packages?.find((p) => p.Id === pack?.Id),
    [packages, pack?.Id],
  );

  useEffect(() => {
    if (!packFromContext) return;
    const t = tags?.filter((tag) =>
      packFromContext?.TagIds?.find((iTag) => tag.Id === iTag),
    );

    setFindedTags(t);
  }, [packFromContext?.TagIds, packageId, pack]);

  const needToConfirm =
    pack.Kind === ItemKind.CourtPortalDeliverance &&
    !pack.ReceiveDate &&
    pack.IsIncoming;

  // const keys: any[] = useMemo(
  //   () => packageData?.data?.ObjectKeys ?? [],
  //   [packageData]
  // );
  const { data: previewData } = EmailService.useGetPreview(
    packageId ?? "",
    false,
    pack?.Kind === 128 ? true : false,
  );

  const lastPackId = useRef<string>(null);

  const [content, setContent] = useState("");
  const [fetchContent, setFetchContent] = useState(false);

  const [decryptError, setDecryptError] = useState(false);

  const decodeEncryptedContent = async () => {
    console.log("decodeEncryptedContent");
    await getKeys(userId!);
    const objectKey = previewData?.data?.ObjectKeys?.[0];

    let parentKey = null;

    if (objectKey?.ParentKeyId) {
      parentKey = previewData?.data.Keys.find(
        (k: IKey) => k?.Id === objectKey?.ParentKeyId,
      );

      if (!parentKey) {
        // waiting to keys changed
        return;
      }
    }
    const encContent = previewData?.data.Content;
    if (!encContent) return;

    // „Elementy wspólne" (retry z unią kluczy wszystkich profili) zniknęły z D1 — jedna
    // firma na użytkownika, bez przełącznika kontekstu, więc nie ma już czym dobierać.
    const content = await decryptPackage(
      userId,
      encContent,
      objectKey,
      parentKey ?? undefined,
    );

    const images = await decodeAndFetchImages(
      userId,
      previewData?.data,
      objectKey!,
      parentKey ?? undefined,
    );

    const parseResult = await parseHTML(content, images);
    console.log("Setting content", parseResult);
    setContentLoaded(true);
    setContent(parseResult.content);
  };

  const handleStatusUpdate = (status?: IStatus) => {
    const newPackages = [...packages];

    const el = newPackages.find((c) => c.Id === pack.Id && c.Kind === pack.Kind);

    if (el) {
      el.StatusId = status?.Id;
    }

    setPackages(newPackages);
    setShowEditStatus(false);
  };

  const [attachmentsLocation, setAttachmentsLocation] =
    useState<string>("center");

  const { options: settings } = useContext(settingsContext);

  useEffect(() => {
    if (settings) {
      const attL = settings.find(
        (x) => x.Type === IOptionType.caseAttachAttachmentsLocation,
      );

      if (attL) {
        setAttachmentsLocation(attL.Value);
      }
    }
  }, [settings]);

  const [showDossier, setShowDossier] = useState<boolean>(false);
  const [usedAttachments, setUsedAttachments] = useState<
    IAttachToCaseFolderLink[]
  >([]);
  const [unusedAttachments, setUnusedAttachments] = useState<IAttachment[]>([]);

  const handleDossierSave = () => {
    manageDossier({
      AttachmentIds: usedAttachments.map((x) => x.AttachmentId),
      OwnerId: pack.Id,
      OwnerKind: pack.Kind,
      Show: true,
      Links: usedAttachments,
    });

    const newPacks = [...packages];

    usedAttachments.forEach((a) => {
      const el = newPacks.find((p) => p.Id === pack.Id);
      if (el) {
        const attach = el.Attachments.find((e) => e.Id === a.AttachmentId);

        if (attach) {
          attach.ShowInDossier = 1;
        }
      }
    });

    setPackages(newPacks);
  };

  useEffect(() => {
    console.log("1asdadsada");
    axiosInstance.post("/list/read", {
      Items: [
        {
          Id: packageId,
          Kind: Number(kind),
        },
      ],
    });
  }, [packageId, PID]);

  function isBase64(str: string) {
    if (!str) return false;
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }

  const getContent = async () => {
    if (contentLoaded) {
      return;
    }
    console.log("getContent");
    setFetchContent(true);
    if (pack.Kind === 128) {
      if (!previewData) {
        return;
      }

      const isEncrypted = previewData?.data?.IsEncrypted;

      if (isEncrypted) {
        setAllowImages(true);
        decodeEncryptedContent();
        return;
      }
      const isImages = await hasImages(previewData?.data?.Content);

      if (!canImages && isImages) {
        setAllowImages(false);
      }

      setContentLoaded(true);
      setContent(
        await addToUrl(
          previewData?.data?.Content,
          isImages && !canImages ? false : true,
        ),
      );

      return;
    }

    setAllowImages(true);

    try {
      const encryptionKey = keys.find(
        (key) => key?.Id === pack?.EncryptionKeyId,
      );

      let parentKey: null | undefined | IKey = null;
      if (encryptionKey?.ParentKeyId) {
        parentKey = keys.find((key) => key?.Id === encryptionKey.ParentKeyId);
      }

      setContent(
        await decryptPackage(
          userId,
          pack.S2,
          encryptionKey,
          parentKey ?? undefined,
        ),
      );
    } catch (e) {
      if (isBase64(pack.S2) && pack.EncryptionKeyId) {
        setDecryptError(true);
        setContent("error");
        return;
      }
      setContent(`${pack.S2}`);
      return;
    } finally {
      setFetchContent(false);
    }
  };

  const packContext = packages.find((p) => p.Id === pack.Id);
  const { keys, setKeys } = useContext(KeysContext);

  useEffect(() => {
    if (contentLoaded) return;
    setDecryptError(false);

    if (
      pack.Unread &&
      pack.Kind !== ItemKind.EDeliveryMessage &&
      pack.Kind !== ItemKind.CourtPortalDeliverance
    ) {
      const newPacks = [...packages];
      const newPack = newPacks.find((p) => p.Id === pack.Id);
      if (newPack) {
        newPack.Unread = false;
        setPackages(newPacks);
      }
    }
    if (
      pack.Kind === 4096 ||
      pack.Kind === 128 ||
      pack.Kind === ItemKind.GovEDeliveryMessage
    ) {
      getContent();
    }

    if (pack.S2) {
      if (
        !keys.filter((k) => k !== undefined).length ||
        !previewData ||
        !pack ||
        !!content.length ||
        fetchContent
      )
        getContent();
      return;
    } else {
      setContent("");
    }
  }, [previewData, pack, keys, canImages]);

  useEffect(() => {
    setUseIframe(previewData?.data?.IsHtml ?? true);
  }, [previewData]);

  const { options } = useContext(settingsContext);

  useEffect(() => {
    const s = options.find((f) => f.Type === IOptionType.showImages)?.Value;

    const can = s === "true";

    setCanImages(can);
    setKeys(
      [
        packageData?.data?.Keys as IKey[],
        packageData?.data?.ObjectKeys as IKey[],
        ...keys,
      ].flat(),
    );
  }, [pack]);

  useEffect(() => {
    console.log("zmieniło się coś", PDFId);
    if (!!PDFId?.length && !!pack && !!pack?.Attachments) {
      const attach = pack?.Attachments?.find(
        (attachment) =>
          attachment.Uri === PDFId.split(":")[2] ||
          attachment.Id === PDFId.split(":")[2],
      );
      console.log("Załącznik do podglądu:", attach);
      if (attach) {
        create(pack.Id, attach, pack.Kind);
      }
    }
  }, [PDFId, pack, keys]);

  useEffect(() => {
    if (lastPackId.current !== pack?.Id) {
      setUseIframe(false);
      setContent("");
      setDecryptError(false);
      setFetchContent(false);
      setContentLoaded(false);
      lastPackId.current = pack?.Id;
    }
  }, [pack, versionId]);

  const { modals, setModals, setOptions } = useContext(ModalsManagerContext);

  const onNewWindow = async (attach: IAttachment) =>
    window.open(
      `${
        import.meta.env.VITE_APP_SITE ?? "https://alfa.pocztaprawnicza.pl"
      }/document?pdf=${pack.Id}:${attach.FileName.replace(":", "")}:${
        attach.Uri ?? attach.Id
      }:${attach.Kind}:${attach.EncryptionKeyId}`,
    );


  useContext(CPluginContext);

  const [update] = useState(false);


  // useEffect(() => {
  //   if (pack && letterId) {
  //     if (!pack.S3) {
  //       return;
  //     }
  //     handleLetterPreview();
  //   }
  // }, [pack, letterId, versionId]);

  const useMenu = !threadId;

  const isFullScreen = window.location.href.search("fullscreen") !== -1;

  const handleUpdateTags = (tags: ITag[]) => {
    const newPackages = [...packages];

    const el = newPackages.find((c) => c.Id === pack.Id && c.Kind === pack.Kind);

    if (el) {
      el.TagIds = tags.map((t) => t.Id);
    }

    setPackages(newPackages);
  };

  // if (PDFId && !blob) {
  //   return (
  //     <div className={styles.loadingWrapper}>
  //       <Loading />
  //     </div>
  //   );
  // }

  const handleAddToCase = () => {
    localStorage.setItem("package", JSON.stringify(pack));
    localStorage.setItem("attach", JSON.stringify(previewAttachment));
    setModals({ ...modals, attachCase: true, hide: false });
  };

  const handleAddToDossier = () => {
    localStorage.setItem("move", "true");
    localStorage.setItem("package", JSON.stringify(pack));
    localStorage.setItem("attach", JSON.stringify(previewAttachment));
    setModals({ ...modals, attachCase: true, hide: false });
  };

  // „Dodaj do rejestru" z paska podglądu załącznika przesyłki: rejestruje
  // podglądany plik jako fakturę (lub umowę) — otwiera formularz z dołączonym
  // plikiem (tryb preloadedFile: sekcja „Dodaj plik" ukryta, pola puste, wybór typu).
  const handleAddToRegistry = (type: "contracts" | "invoices") => {
    const fileName =
      previewAttachment?.Label ?? previewAttachment?.FileName ?? "dokument.pdf";
    if (type === "contracts") {
      const opts = new ContractRegistryModalOptions();
      opts.file = blob;
      opts.fileName = fileName;
      setOptions(opts);
      setModals({ ...modals, createContractEntry: true, hide: false });
    } else {
      const opts = new InvoiceRegistryModalOptions();
      opts.file = blob;
      opts.fileName = fileName;
      setOptions(opts);
      setModals({ ...modals, createInvoiceRegistryEntry: true, hide: false });
    }
  };

  const handleAddOnePackage = (attachment: IAttachment) => {
    if (checkIsArchive(attachment.FileName)) {
      setShowArchive(attachment);
    } else {
      setUsedAttachments([]);
      setUnusedAttachments(pack.Attachments);
      setShowDossier(true);
    }
  };

  const channels = pack?.Receivers?.map((r) => r.ParcelType);
  //@ts-ignore
  const uniqChannels = [...new Set(channels)];

  const attachments = packContext?.Attachments ?? pack.Attachments;
  const a = PDFId
    ? pack?.Attachments?.find((att) => att.Uri === PDFId.split(":")[2])
    : null;

  const pdfRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (pdfRef.current) {
      console.log("adding show class");
      pdfRef.current.classList.add(styles.show);
    }
  }, [pdfRef.current]);

  const packageRender = () => {
    return (
      <div className={`${styles.package} ${pack.Pass ? styles.passed : ""}`}>
        <ICALHeader pack={pack} />
        {pack.Pass && (
          <div className={styles.passedHeader}>
            <FwdIcon></FwdIcon> {t("packages.forwardedMessage")}
          </div>
        )}
        <div className={styles.personWrapper}>
          <div className={styles.person}>
            <Avatar className={styles.avastar} name={pack.Sender ?? ""} />
            <div className={styles.senderWrapper}>
              <div className={styles.nameAndDate}>
                <div className={styles.name}>{pack?.Sender}</div>
                <div
                  className={styles.date}
                  ref={dateRef}
                  onClick={() => setShowDateMetic(true)}
                >
                  {moment(pack.ReceiveDate ?? pack.CreationDate)
                    .format("DD.MM.YYYY")
                    .toString()}
                </div>
              </div>
              <div className={styles.titleWrapper}>
                <div className={styles.titlePack}>{pack.S1}</div>
                <div className={styles.icons}>
                  <IconsState
                    onDownload={onDownload}
                    previewData={previewData}
                    customY={-170}
                    keys={keys}
                    msg={packages.find((p) => p.Id === pack.Id) ?? pack}
                  />
                </div>
              </div>
              <div className={styles.toWrapper}>
                <div className={styles.to}>
                  {t("packages.toLabel")}:
                  <div className={styles.toList}>
                    {pack?.Receivers &&
                      pack?.Receivers?.filter((r) => !r.Cc && !r.Bcc).length >
                        0 && (
                        <div className={styles.receiver}>
                          {pack.Receivers.filter((r) => !r.Cc && !r.Bcc)[0]
                            .Name ??
                            pack.Receivers.filter((r) => !r.Cc && !r.Bcc)[0]
                              .Email}
                        </div>
                      )}
                    {pack?.Receivers &&
                      pack?.Receivers?.filter((r) => !r.Cc && !r.Bcc).length >
                        1 && (
                        <>
                          <div
                            className={styles.moreReceivers}
                            ref={receiversReference}
                            onClick={() => setShowReceivers(!showReceivers)}
                          >
                            <GroupIcon></GroupIcon> +{" "}
                            {pack.Receivers?.filter((r) => !r.Cc && !r.Bcc)
                              .length - 1}
                          </div>

                          {showReceivers && (
                            <ModalLayout refWrapper={receiversReference}>
                              <PackageReceiversModal
                                toggle={() => setShowReceivers(false)}
                                pack={pack}
                                cc={false}
                              />
                            </ModalLayout>
                          )}
                        </>
                      )}
                  </div>
                  {packCcReceivers && packCcReceivers.length > 0 && (
                    <div className={styles.ccList}>
                      <div className={styles.toList}>
                        {t("packages.ccLabel")}:
                        <div className={styles.receiver}>
                          {packCcReceivers[0].Name ?? packCcReceivers[0].Email}
                        </div>
                        {packCcReceivers.length > 1 && (
                          <>
                            <div
                              className={styles.moreReceivers}
                              ref={receiversCcReference}
                              onClick={() =>
                                setShowCcReceivers(!showCcReceivers)
                              }
                            >
                              <GroupIcon></GroupIcon> +{" "}
                              {packCcReceivers.length - 1}
                            </div>

                            {showCcReceivers && (
                              <ModalLayout refWrapper={receiversCcReference}>
                                <PackageReceiversModal
                                  toggle={() => setShowCcReceivers(false)}
                                  pack={pack}
                                  cc={true}
                                />
                              </ModalLayout>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div ref={tagsRef}>
                {findedTags.map((tag) => (
                  <Chip
                    small
                    element={<>{tag.Name}</>}
                    onClick={(e) => {
                      tagsRef;
                      setShowEditTags(true);
                      setTagPopperRef(e.target);
                    }}
                  />
                ))}
                {isSending && uniqChannels.length >= 2 && (
                  <div className={styles.multiWrapper}>
                    {pack?.Receivers?.length >= 2 && (
                      <div
                        onClick={() => setShowMulti(!showMulti)}
                        ref={reference}
                        className={styles.multi}
                      >
                        {t("packages.multiPackage")}
                      </div>
                    )}

                    {showMulti && (
                      <ModalLayout refWrapper={reference}>
                        <MultiPackageModal
                          toggle={() => setShowMulti(false)}
                          pack={pack}
                        />
                      </ModalLayout>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.borderLine}>
          <div className={styles.line}></div>
        </div>
        {!useIframe && content && (
          <div
            dangerouslySetInnerHTML={{ __html: sanitizeUserHtml(content) }}
            className={styles.body}
          ></div>
        )}

        {useIframe && (
          <>
            {content && <EmailViewer sourceContent={content} />}
            {!content && <Loading />}
          </>
        )}

        <div
          className={classNames(
            styles.attachments,
            !content ? styles.marginTop : undefined,
          )}
        >
          {attachments?.map((attachment) => (
            <div key={attachment.Id} className={styles.attach}>
              <PackageAttachment
                onAddDossier={() => handleAddOnePackage(attachment)}
                date={moment(pack.ReceiveDate ?? pack.CreationDate)
                  .format("HH:MM | DD.MM.YYYY")
                  .toString()}
                onNewWindow={onNewWindow}
                onPreview={(attach) => {
                  const isAllowed = checkIsAllowed(attachment.FileName);
                  const isArchive = checkIsArchive(attachment.FileName);

                  if (isArchive) {
                    setShowArchive(attach);
                    return;
                  }

                  if (!isAllowed) {
                    showNotSupportedNotification();
                    return;
                  }
                  // onPreview(pack, attach, previewData);
                  const newUrl = `${window.location.pathname}?pdf=${
                    pack.Id
                  }:${attach.FileName.replace(":", "")}:${
                    attach.Uri ?? attach.Id
                  }:${attach.Kind}:${attach.EncryptionKeyId}`;
                  navigate(newUrl);
                }}
                onDownload={(attach) => onDownload(pack, attach, previewData)}
                attachment={attachment}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const handleMobileBack = () => {
    window.history.back();
  };

  if (pack?.Expired && pack.IsIncoming) {
    return (
      <div className={classNames(styles.wrapper, className)}>
        <div className={`${styles.header} ${headerClassName}`}></div>
        <div className={styles.package}>
          <ExpiredModal refetch={refetch} pack={pack} />
        </div>
      </div>
    );
  }

  if (needToConfirm) {
    return (
      <div className={classNames(styles.wrapper, className)}>
        <div className={`${styles.header} ${headerClassName}`}></div>
        <div className={styles.package}>
          <ReceiveModal refetch={refetch} pack={pack} />
        </div>
      </div>
    );
  }

  // Przesyłka przychodząca zablokowana do czasu zwiększenia pakietu — limit darmowych
  // przesyłek (payment) lub brak miejsca na dysku (storage). Zamiast treści pokazujemy
  // informację o blokadzie + CTA do pakietów. Payment ma pierwszeństwo, gdyby oba ustawione.
  if ((pack?.IsPendingPayment || pack?.IsPendingStorage) && pack.IsIncoming) {
    return (
      <div className={classNames(styles.wrapper, className)}>
        <div className={`${styles.header} ${headerClassName}`}></div>
        <div className={styles.package}>
          <PendingPaymentModal
            pack={pack}
            variant={pack.IsPendingPayment ? "payment" : "storage"}
          />
        </div>
      </div>
    );
  }

  if (selectedElements && selectedElements.length > 1) {
    return <SelectedElementsPanel count={selectedElements.length} />;
  }

  if ((showVersion || update) && !isFullScreen) {
    return (
      <PDFViewer file={new Blob([])} showVersion={showVersion || update} />
    );
  }

  if (pack && letterId && !pack.S3) {
    return (
      <div className={styles.errorWrapper}>
        <ErrorScreen text={t("errors.documentNotReady")} />
      </div>
    );
  }

  if (
    decryptError &&
    pack.Kind !== ItemKind.CourtPortalDeliverance &&
    pack.Kind !== ItemKind.CourtPortalDocument
  ) {
    return (
      <div className={styles.errorWrapper}>
        <ErrorScreen text={t("errors.cannotDecrypt")} />
      </div>
    );
  }

  if (packFromContext?.isDelete) {
    return <EmptyPanel />;
  }

  if (!pack?.Id && !isLoading) {
    return (
      <div className={styles.wrap}>
        <ErrorScreen text={t("errors.packageNotFound")} />;
      </div>
    );
  }

  return (
    <>
      <div className={classNames(styles.wrapper, className)}>
        {showCase && (
          <PackageCaseModal
            toggle={setShowCase}
            CaseId={pack?.Case?.Id}
            Package={pack}
          />
        )}
        <div className={`${styles.header} ${headerClassName}`}>
          {isMobile && (
            <div className={styles.tools}>
              <div className={styles.backButton}>
                <BackIcon onClick={() => handleMobileBack()}></BackIcon>
              </div>
            </div>
          )}
          {useMenu && (
            <div ref={refWrapper} className={styles.options}>
              {pack && (
                <div ref={refWrapper2} className={styles.options}>
                  <OptionsCard
                    content={content}
                    className={isFullScreen && !cc ? "" : styles.opt}
                    rightSide={true}
                    selectedElements={selectedElements ?? []}
                    setSelectedElements={setSelectedElements}
                    showOptions={true}
                    pack={pack}
                    refetch={() => {}}
                    refWrapper={refWrapper}
                    onClickAttachIcon={setShowAttach}
                    showEditTags={showEditTags}
                    setShowEditTags={(v, r) => {
                      setEditTagRef(r);
                      setShowEditTags(v);
                    }}
                    showEditStatus={showEditStatus}
                    setShowEditStatus={(v, r) => {
                      setEditStatusRef(r);
                      setShowEditStatus(v);
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        {!allowImages && (
          <div className={styles.info}>
            <div className={styles.text}>
              {t("packages.containsImages")}
            </div>
            <div className={styles.button}>
              <Button
                className={styles.btn}
                onClick={() => {
                  setCanImages(true);
                  setAllowImages(true);
                }}
                text={t("packages.showFullContent")}
              />
            </div>
          </div>
        )}
        {pack.Pass && (
          <div className={styles.passInfo}>
            <div className={styles.personWrapper}>
              <div className={styles.person}>
                <Avatar
                  className={styles.avastar}
                  name={pack.Pass.From ?? ""}
                />
                <div className={styles.senderWrapper}>
                  <div className={styles.nameAndDate}>
                    <div className={styles.name}>{pack?.Pass.From}</div>
                    <div className={styles.date}>
                      {moment(pack.Pass.Date).format("DD.MM.YYYY").toString()}
                    </div>
                  </div>
                  <div className={styles.titleWrapper}>
                    <div className={styles.titlePack}>
                      {pack.Pass.Title ?? pack.S1}
                    </div>
                  </div>
                  <div className={styles.toWrapper}>
                    <div className={styles.to}>
                      {t("packages.toLabel")}:
                      <div className={styles.toList}>
                        <div className={styles.receiver}>{pack.Pass.To}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.passedHeader}>
              <FwdIcon></FwdIcon> {t("packages.forwarderDescription")}
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeUserHtml(
                  pack.Pass.Content ?? t("common.noDescription"),
                ),
              }}
              className={styles.body}
            ></div>
            {packageRender()}
          </div>
        )}

        {!pack.Pass && packageRender()}

        {showInstallPlugin && (
          <PluginNotExist
            message={t("plugin.installForPreview")}
            handleClose={() => setShowInstallPlugin(false)}
          ></PluginNotExist>
        )}

        {showArchive && (
          <ZipAttachToDossierModal
            caseId={pack.Case?.Id}
            itemId={pack.Id}
            itemKind={pack.Kind}
            attachmentId={showArchive.Id}
            fileUri={showArchive.Uri ?? showArchive.FileUri}
            fileName={showArchive.FileName}
            encryptionKeyId={pack.EncryptionKeyId}
            toggle={() => setShowArchive(null)}
            refetch={() => {}}
          ></ZipAttachToDossierModal>
        )}

        {showEditTags && (
          <Popper
            anchorEl={editTagRef?.current ?? tagPopperRef ?? tagsRef?.current}
            open={showEditTags}
            setOpen={setShowEditTags}
            placement="bottom-start"
          >
            <ChooseTagNew
              toTag={pack}
              toggle={setShowEditTags}
              updateTags={handleUpdateTags}
              type={TagType.Incoming}
            />
          </Popper>
        )}

        {showEditStatus && (
          <Popper
            anchorEl={
              editStatusRef?.current ?? refWrapper2?.current ?? tagsRef?.current
            }
            open={showEditStatus}
            setOpen={setShowEditStatus}
            placement="bottom-end"
          >
            <StatusModal
              item={pack}
              toggle={setShowEditStatus}
              selectedStatus={null}
              afterUpdate={handleStatusUpdate}
            />
          </Popper>
        )}

        <Popper
          open={showDateMetric}
          anchorEl={dateRef?.current}
          setOpen={setShowDateMetic}
        >
          <MetricDatesModal toggle={setShowDateMetic} pack={pack} />
        </Popper>

        {blob &&
          !!PDFId?.length &&
          !isFullScreen &&
          !isDownload &&
          pack?.Attachments && (
            <div className={styles.pdfW} ref={pdfRef}>
              <PDFViewer
                title={a?.Label ? a.Label : a?.FileName ?? ""}
                file={blob}
                onCloseButton={() => {
                  pdfRef.current.classList.remove(styles.show);
                  pdfRef.current.classList.add(styles.hide);
                  setTimeout(() => {
                    removeBlob();
                    const url = new URL(window.location.href); // Pobierz obecny URL
                    url.searchParams.delete("pdf"); // Usuń parametr 'pdf'

                    // Zaktualizuj URL bez przeładowania strony, zachowując inne parametry
                    navigate(`${url.pathname}${url.search}`);
                  }, 1000);
                }}
                handleAddToCase={!pack.Case ? handleAddToCase : undefined}
                handleAddToDossier={pack.Case ? handleAddToDossier : undefined}
                handleAddToRegistry={handleAddToRegistry}
              />
            </div>
          )}

        {isMobile && (
          <>
            <Paper
              sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                borderLeft: "none !important",
                borderRight: "none !important",
                borderBottom: "none !important",
                borderRadius: "0 !important",
              }}
              elevation={3}
            >
              <BottomNavigation
                sx={{
                  bgcolor: "#fdf8fd",
                  //borderTop: "1px solid #c9c5d0",
                }}
                onChange={(event, newValue) => {
                  if (newValue === 0) {
                    //setModals({ ...modals, menu: true });
                  }
                  if (newValue === 1) {
                    //setUnread(!unread);
                  }
                  if (newValue === 2) {
                    //handleRefresh();
                  }
                  //setValue(newValue);
                }}
              >
                <BottomNavigationAction title={t("common.menu")} icon={<TrashIcon />} />
                <BottomNavigationAction
                  title={t("tooltips.linkToCase")}
                  icon={<CaseIcon />}
                />
                <BottomNavigationAction
                  title={t("packages.replyAction")}
                  icon={<ReplyIcon />}
                />

                <BottomNavigationAction
                  title={t("sidebar.createNew")}
                  icon={
                    <AddIcon
                      onClick={() => {
                        setModals({ ...modals, createMobile: true });
                      }}
                      className={styles.addIcon}
                    />
                  }
                />
              </BottomNavigation>
            </Paper>
          </>
        )}
      </div>

      {showDossier && (
        <>
          {attachmentsLocation === "center" && (
            <ModalLayout dock={DockPosition.CENTER} showBg={true}>
              <AttachToCaseModalAttachments
                toggle={(c) => setShowDossier(c)}
                c={pack.Case}
                pack={pack}
                unusedAttachments={unusedAttachments}
                setUnusedAttachments={setUnusedAttachments}
                setUsedAttachments={setUsedAttachments}
                usedAttachments={usedAttachments}
                onSave={handleDossierSave}
                position="center"
              ></AttachToCaseModalAttachments>
            </ModalLayout>
          )}
          {attachmentsLocation !== "center" && (
            <ModalLayout
              dock={DockPosition.DISABLED}
              off={true}
              customX={8}
              customY={0}
              ignore
              isAnimation
              fullHeight={true}
              name="attachCase"
            >
              <AttachToCaseModalAttachments
                toggle={(c) => setShowDossier(c)}
                c={pack.Case}
                pack={pack}
                unusedAttachments={unusedAttachments}
                setUnusedAttachments={setUnusedAttachments}
                setUsedAttachments={setUsedAttachments}
                usedAttachments={usedAttachments}
                onSave={handleDossierSave}
                className={styles.nomodal}
                position="left"
              ></AttachToCaseModalAttachments>
            </ModalLayout>
          )}
        </>
      )}
    </>
  );
};

export default Package;
